/* One header height on every page (U6 and U9, 2026-11-03): 72px, so the title does not move by a few pixels as
   a person goes from place to place (it measured 70, 73 and 98). The title is one line, cut with an
   ellipsis; a long one is its whole text on hover. Tokens only (ADR-0007). */
.head {
  display: flex;
  align-items: center;
  gap: 12px;
  grid-column: 1 / -1;
  flex: 0 0 auto;
  box-sizing: border-box;
  height: 72px;
  min-width: 0;
  padding: 0 16px;
}

.badge {
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border: 1px solid var(--accent-line);
  border-radius: var(--radius-chip);
  background: var(--accent-w);
  color: var(--accent);
}

.titles {
  display: flex;
  flex: 1 1 auto;
  /* Top-aligned, so the title is in the same place whether or not the header has a label (baseline alignment
     moved it two pixels). The label shares the eyebrow's line. */
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
}

/* The label is the first thing to give up its room, and is cut like the title. */
.label {
  min-width: 0;
  overflow: hidden;
  color: var(--muted);
  font-size: var(--t-dense);
  font-weight: 600;
  line-height: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
}

@media (max-width: 560px) {
  .head {
    flex-wrap: wrap;
    height: auto;
    min-height: 72px;
    padding-block: 8px;
  }

  .actions {
    flex: 1 1 100%;
  }
}
